import React from 'react';
import { Box, Typography, Button, Container, ThemeProvider, createTheme } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SearchOffIcon from '@mui/icons-material/SearchOff';
import { keyframes } from '@mui/system';

const theme = createTheme({
  palette: {
    primary: {
      main: "#00A7B5",
    },
    secondary: {
      main: "#1C355E",
    },
  },
});

const float = keyframes`
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-15px);
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const NotFound = () => {
  const handleGoHome = () => {
    window.location.href = '/';
  };

  const handleGoBack = () => {
    window.history.back();
  };

  return (
    <ThemeProvider theme={theme}>
      <Box
        sx={{
          minHeight: '100vh',
          backgroundColor: '#f8f9fa',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          p: 3,
        }}
      >
      <Container maxWidth="md">
        <Box
          sx={{
            textAlign: 'center',
            animation: `${fadeIn} 0.6s ease-out`,
          }}
        >
          {/* Floating icon */}
          <Box
            sx={{
              mb: 4,
              display: 'flex',
              justifyContent: 'center',
              animation: `${float} 3s ease-in-out infinite`,
            }}
          >
            <Box
              sx={{
                width: { xs: 100, md: 120 },
                height: { xs: 100, md: 120 },
                borderRadius: '50%',
                backgroundColor: '#00A7B5',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 10px 30px rgba(23, 162, 184, 0.2)',
              }}
            >
              <SearchOffIcon
                sx={{
                  fontSize: { xs: 50, md: 60 },
                  color: 'white'
                }}
              />
            </Box>
          </Box>

          {/* 404 Number */}
          <Typography
            sx={{
              fontSize: { xs: '6rem', sm: '8rem', md: '10rem' },
              fontWeight: 800,
              color: '#1C355E',
              mb: 2,
              lineHeight: 1,
              letterSpacing: '-0.02em',
            }}
          >
            404
          </Typography>

          {/* Title */}
          <Typography
            variant="h4"
            sx={{
              color: '#1C355E',
              fontWeight: 600,
              mb: 2,
              fontSize: { xs: '1.5rem', md: '2rem' },
            }}
          >
            Sayfa Bulunamadı
          </Typography>

          {/* Description */}
          <Typography
            variant="body1"
            sx={{
              color: '#6c757d',
              mb: 5,
              maxWidth: '500px',
              mx: 'auto',
              fontSize: { xs: '1rem', md: '1.125rem' },
              lineHeight: 1.7,
            }}
          >
            Aradığınız sayfa taşınmış, silinmiş veya hiç var olmamış olabilir.
            Lütfen ana sayfaya dönün veya önceki sayfaya geri gidin.
          </Typography>

          {/* Action buttons */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              gap: 2,
              justifyContent: 'center',
            }}
          >
            <Button
              variant="contained"
              size="large"
              startIcon={<HomeIcon />}
              onClick={handleGoHome}
              sx={{
                px: 4,
                py: 1.5,
                backgroundColor: '#00A7B5',
                fontWeight: 600,
                fontSize: '1rem',
                borderRadius: '8px',
                textTransform: 'none',
                boxShadow: '0 4px 12px rgba(23, 162, 184, 0.25)',
                '&:hover': {
                  backgroundColor: '#138496',
                  transform: 'translateY(-2px)',
                  boxShadow: '0 6px 20px rgba(23, 162, 184, 0.35)',
                },
              }}
            >
              Ana Sayfaya Dön
            </Button>

            <Button
              variant="outlined"
              size="large"
              startIcon={<ArrowBackIcon />}
              onClick={handleGoBack}
              sx={{
                px: 4,
                py: 1.5,
                color: '#1C355E',
                borderColor: '#1C355E',
                fontWeight: 600,
                fontSize: '1rem',
                borderRadius: '8px',
                textTransform: 'none',
                '&:hover': {
                  borderColor: '#1C355E',
                  backgroundColor: 'rgba(28, 53, 94, 0.04)',
                  transform: 'translateY(-2px)',
                },
              }}
            >
              Geri Dön
            </Button>
          </Box>

          {/* Decorative line */}
          <Box
            sx={{
              mt: 6,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 2,
            }}
          >
            <Box
              sx={{
                width: 60,
                height: 2,
                backgroundColor: '#00A7B5',
                borderRadius: 1,
              }}
            />
            <Typography
              variant="caption"
              sx={{
                color: '#6c757d',
                fontSize: '0.875rem',
              }}
            >
              Hata Kodu: 404
            </Typography>
            <Box
              sx={{
                width: 60,
                height: 2,
                backgroundColor: '#00A7B5',
                borderRadius: 1,
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
    </ThemeProvider>
  );
};

export default NotFound;